import { FundingType, IFunding } from '@bytel/leviator';
import {
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TitleMarkup,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

type FundingLegalsProps =
    | {
          funding: IFunding;
          type?: never;
      }
    | {
          type: FundingType.YOUNITED;
          funding?: never;
      };

export function FundingLegals({ type, funding }: Readonly<FundingLegalsProps>) {
    if (funding && (funding.type === FundingType.YOUNITED || funding.type === FundingType.SWAPPY)) {
        type = FundingType.YOUNITED;
    }

    return (
        <AccordionItem id='product-detail-funding-legals' data-cy='funding-legals' open>
            <AccordionHeader>
                <Title markup={TitleMarkup.H2} level={TitleLevels.SIX}>
                    Mentions légales du financement
                </Title>
            </AccordionHeader>
            <AccordionBody>
                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE}>
                    Attention, un crédit coûte de l&apos;argent et doit être remboursé.
                </Text>
                {funding && (
                    <Text level={TextLevels.TWO}>
                        <b>{funding.installments} mensualités de </b>
                        <InlinePrice amount={funding.monthlyAmount} period='mois' level={TextLevels.TWO} />.{' '}
                        <b>
                            Montant total dû <InlinePrice amount={funding.totalFinancingCost} level={TextLevels.TWO} />
                        </b>{' '}
                        (hors assurance facultative). <b>TAEG fixe&nbsp;: {funding.APR?.toLocaleString()}%</b>. Taux
                        débiteur fixe de {funding.fixedInterestRate?.toLocaleString()}%.
                    </Text>
                )}
                {type === FundingType.YOUNITED && <YounitedLegals />}
            </AccordionBody>
        </AccordionItem>
    );
}

function YounitedLegals() {
    return (
        <>
            <Text level={TextLevels.TWO}>
                Younited est agréé en tant qu&apos;établissement de crédit - Prestataire de Services
                d&apos;Investissement par l&apos;Autorité de Contrôle Prudentiel et de Résolution (ACPR, n°
                d&apos;agrément&nbsp;: 16488).
            </Text>
            <Text level={TextLevels.TWO}>
                Le financement est accordé sous réserve d&apos;acceptation définitive après l&apos;étude de votre
                dossier. Vous disposez d&apos;un droit de rétractation de 14 jours calendaires révolus à compter de la
                signature de l&apos;offre de contrat de crédit.
            </Text>
            <Text level={TextLevels.TWO}>
                Younited&nbsp;: SA à Directoire et Conseil de Surveillance au capital de 2&nbsp;000&nbsp;785€ - Siège
                social&nbsp;: 21 rue de Châteaudun - 75009 PARIS - RCS de Paris 517&nbsp;586&nbsp;376 - Numéro ORIAS
                11061269
            </Text>
        </>
    );
}
